import React from 'react';
import { motion } from 'framer-motion';
import { Link, NavLink } from 'react-router-dom';

import Hamburger from './Hamburger';
import routes from '../../data/routes';

const navVariants = {
  hidden: { opacity: 0, y: -12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
      when: 'beforeChildren',
    },
  },
};

const listVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: -8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: [0.24, 1, 0.3, 1] } },
};

// Websites Navbar, displays routes defined in 'src/data/routes'
const Navigation = () => (
  <motion.header id="header" variants={navVariants} initial="hidden" animate="visible">
    <h1 className="index-link">
      {routes
        .filter((l) => l.index)
        .map((l) => (
          <Link key={l.label} to={l.path}>
            {l.label}
          </Link>
        ))}
    </h1>
    <nav className="links">
      <motion.ul variants={listVariants}>
        {routes
          .filter((l) => !l.index)
          .map((l) => (
            <motion.li key={l.label} variants={itemVariants}>
              <NavLink
                to={l.path}
                className={({ isActive }) => (isActive ? 'nav-link is-active' : 'nav-link')}
              >
                {l.label}
              </NavLink>
            </motion.li>
          ))}
      </motion.ul>
    </nav>
    <Hamburger />
  </motion.header>
);

export default Navigation;
